import { Box, Stack, Typography } from '@mui/material';
import { CircleSlash, MessageSquareOff } from 'lucide-react';
import {
  useConversationSubjects,
  useSiteOverview,
} from 'src/graphql/entities/address-summary';
import {
  NotEnoughEvidence,
  SentimentPanel,
  ShortSummaryPanel,
  SiteHealthPanel,
  SupportBriefPanel,
} from './site-overview.elements';
import { citedConversationIds } from './site-overview.helpers';
import { healthSentimentGridSx, loadingCopySx, pageStackSx } from './site-overview.styles';

export const SiteOverview = ({ addressId }: { addressId: string }) => {
  const { overview, shortSummary, problem, loading, allowed } = useSiteOverview(addressId);
  const { subjects, loading: citationsLoading } = useConversationSubjects(
    overview ? citedConversationIds(overview) : [],
  );

  if (!allowed) {
    return null;
  }

  if (loading) {
    return <Typography sx={loadingCopySx}>Loading summary…</Typography>;
  }

  if (problem || !overview) {
    return (
      <Stack spacing={2} sx={pageStackSx}>
        {shortSummary ? <ShortSummaryPanel shortSummary={shortSummary} /> : null}
        <Box sx={healthSentimentGridSx}>
          <NotEnoughEvidence title="Site Health" icon={<CircleSlash />} />
          <NotEnoughEvidence title="Current Site Sentiment" icon={<MessageSquareOff />} />
        </Box>
      </Stack>
    );
  }

  return (
    <Stack spacing={2} sx={pageStackSx}>
      {shortSummary ? <ShortSummaryPanel shortSummary={shortSummary} /> : null}
      <Box sx={healthSentimentGridSx}>
        <SiteHealthPanel
          overview={overview}
          subjects={subjects}
          citationsLoading={citationsLoading}
        />
        <SentimentPanel
          overview={overview}
          subjects={subjects}
          citationsLoading={citationsLoading}
        />
      </Box>
      <SupportBriefPanel overview={overview} />
    </Stack>
  );
};
